<script setup lang="ts">
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
import { useUiState } from '@/stores/uiState'
import { useGameState } from '@/stores/gameState'
import Button from '../ui/button/Button.vue'
import { Icon } from '@iconify/vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'

const router = useRouter()
const uiState = useUiState()
const { getSeatedTableId } = storeToRefs(useGameState())
const { clearSeatedTableId } = useGameState()

const goToTheSeatedTable = () => {
  router.push(`/room/${getSeatedTableId.value}`)
  closeModal()
}

const closeModal = () => {
  clearSeatedTableId()
  uiState.modals.seatPlayerAlready.close()
}
</script>

<template>
  <modal-wrapper v-if="uiState.modals.seatPlayerAlready.isOpen">
    <div class="fixed inset-0 flex w-full items-center justify-center">
      <div
        class="relative flex h-full w-full flex-col justify-center bg-[#0D1526] px-6 py-6 text-white/75 shadow-lg md:h-auto md:max-w-[560px] md:rounded-xl md:border md:border-[#CCCCCC2E]"
      >
        <button
          class="absolute right-4 top-4 rounded-full bg-white/10 p-1 text-white hover:bg-white/15"
          @click="closeModal"
          aria-label="Close welcome modal"
        >
          <Icon width="24" height="24" icon="famicons:close-outline" />
        </button>

        <div class="mt-3 flex flex-col items-center justify-center">
          <h1 class="text-center text-xl/10 font-semibold text-white">
            You are already playing on another table
          </h1>
        </div>
        <div class="mx-4 space-y-2 text-center md:mx-8 md:space-y-4">
          <p class="text">Leave current table to join/create another.</p>
        </div>
        <div class="mt-6 grid grid-cols-2 gap-4">
          <Button
            class="w-full border border-white/10 bg-[#19233A] p-2 text-xs text-[#989CAF] md:p-6 md:text-sm"
            variant="default"
            @click="closeModal"
          >
            Close
          </Button>
          <Button
            class="w-full bg-gradient-to-r from-[#005EDA] to-[#F3004E] p-2 text-xs md:p-6 md:text-sm"
            variant="accent"
            @click="goToTheSeatedTable"
          >
            Go to your table
          </Button>
        </div>
      </div>
    </div>
  </modal-wrapper>
</template>
